import { angularAMD } from "@pebblepad/amd";
import "../../../../utilities/baseUrlsFactory";
import "../../../../assetStore/services/assetStoreService";
import "../../../../assetViews/sidebar/shares/shares";
import "../../../../assetViews/sidebar/submissions/submissions";
import "../../../../extensions/arrayExtensions";
import "../../../../expandable/expandable";
import "../../../../tagger/tagger";
import "../../../../assetsWithLinks/directives/assetsWithLinks";
import "../../../../userAgent/userAgent.service";
import "../../../../user/user.service";
import template from "../templates/reportInappropriate.html";
import { launchPublicReportDialog, launchReportDialog } from "@pjs/asset-core";

angularAMD.directive("reportInappropriate", [
    "$q",
    "$sce",
    "$rootScope",
    "User",
    function ($q, $sce, $rootScope, User) {
        return {
            template: template,
            restrict: "E",
            scope: {
                info: "=?info",
                assetId: "=assetId"
            },
            controller: [
                "$scope",
                "$element",
                "$attrs",
                "$filter",
                function ($scope, $element, $attrs, $filter) {
                    $scope.multiLanguageService = $rootScope.multiLanguageService;

                    $scope.launchDialog = ($event) => {
                        const userDto = User.getDto();
                        const isLoggedIn = userDto !== null;

                        const author = $scope.info.Authors[0];
                        const authorName = `${author.Forename} ${author.Surname}`;
                        const subtext = $scope.multiLanguageService.getString("sidebar.inappropriate.asset_summary", {
                            name: authorName,
                            time: $filter("pebbleDate")($scope.info.CreatedOn, "timeOnly"),
                            date: $filter("pebbleDate")($scope.info.CreatedOn, "dateOnly")
                        });
                        const assetSummary = {
                            title: $scope.info.Title,
                            subtext: subtext,
                            mainType: $scope.info.MainType,
                            subType: $scope.info.SubType
                        };

                        let trigger = document.activeElement;
                        if (trigger === document.body) {
                            trigger = $event.currentTarget;
                        }

                        if (isLoggedIn) {
                            launchReportDialog($scope.assetId, assetSummary, trigger);
                            return;
                        }

                        launchPublicReportDialog($scope.assetId, assetSummary, trigger);
                    };
                }
            ]
        };
    }
]);
